import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "64",
  height: "44",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "30",
      height: "20",
      fill: "#528BFF",
      rx: "4"
    }, null, -1 /* HOISTED */),
    _createElementVNode("rect", {
      width: "30",
      height: "20",
      x: "34",
      fill: "#EAECF0",
      rx: "4"
    }, null, -1 /* HOISTED */),
    _createElementVNode("rect", {
      width: "30",
      height: "20",
      y: "24",
      fill: "#EAECF0",
      rx: "4"
    }, null, -1 /* HOISTED */),
    _createElementVNode("rect", {
      width: "30",
      height: "20",
      x: "34",
      y: "24",
      fill: "#EAECF0",
      rx: "4"
    }, null, -1 /* HOISTED */)
  ])))
}
export default { render: render }